import { SUPPLEMENTAL_BENEFIT } from 'core/constants/products'

function parseSupplementalBenefitPlans(quoteResponse) {
  if (quoteResponse.plansByType[SUPPLEMENTAL_BENEFIT]) {
    quoteResponse.plansByType[SUPPLEMENTAL_BENEFIT].forEach(id => {
      const plan = quoteResponse.plans[id]
      plan.durations = plan.durations
        .filter(duration => duration.sequence === 1)
        .reduce((acc, duration) => {
          const policyDuration = duration.policyDuration

          acc[policyDuration] = acc[policyDuration] || {}
          acc[policyDuration][duration.recurrence] = duration

          return acc
        }, {})
    })
  }
}

export default parseSupplementalBenefitPlans
